import { define, html } from "hybrids";

interface VBroadcastErrorMessage {
  code: string;
}

export default define<VBroadcastErrorMessage>({
  tag: "v-broadcast-error-message",
  code: "404",
  render: ({ code }) => html`
    <v-ui-flexbox layout="start center" gap="large">
      <v-ui-flexbox flow="row" layout="center" gap="medium">
        ${Array.from(code).map((char, index) =>
          index === 1 && char === "0"
            ? html`<v-ui-icon name="drums" color=""></v-ui-icon>`
            : html`<v-ui-text class="code-char">${char}</v-ui-text>`
        )}
      </v-ui-flexbox>
      <div id="content"><slot></slot></div>
      <v-ui-button href="/" color="primary" type="long">Home Page</v-ui-button>
    </v-ui-flexbox>
  `.css`
    :host {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      text-align: center;
      padding: var(--v-ui-layout-spacing);
    }

    .code-char {
      font-size: 112px;
      line-height: 112px;
      font-weight: bold;
    }
  `,
});
